import React from 'react';
import { createPortal } from 'react-dom';
import { X, TrendingUp } from 'lucide-react';

const MOCK_PERFORMANCE = [
  { id: 1, name: 'Employee One', email: 'employee@hr.com', initial: 'E', total: 0, completed: 0, pending: 0, overdue: 0, rate: 0 },
  { id: 2, name: 'Yasmin Parveen', email: 'yasminparveen066@gmail.com', initial: 'Y', total: 2, completed: 0, pending: 0, overdue: 2, rate: 0 },
  { id: 3, name: 'Ravi Kumar', email: 'ravi@gmail.com', initial: 'R', total: 3, completed: 0, pending: 0, overdue: 3, rate: 0 },
  { id: 4, name: 'Ashiya Parveen', email: 'ashiya@gmail.com', initial: 'A', total: 2, completed: 0, pending: 0, overdue: 2, rate: 0 },
  { id: 5, name: 'Aryan Kr Singh', email: 'aryan@gmail.com', initial: 'A', total: 2, completed: 1, pending: 0, overdue: 1, rate: 50 },
  { id: 6, name: 'Amit Kumar', email: 'amit@gmail.com', initial: 'A', total: 2, completed: 0, pending: 0, overdue: 2, rate: 0 },
  { id: 7, name: 'chandan kumar', email: 'chandanbdsc@gmail.com', initial: 'c', total: 3, completed: 1, pending: 0, overdue: 2, rate: 33.3 },
];

export default function PerformanceReportModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[999] flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity" 
        onClick={onClose}
      ></div>
      
      <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-[800px] flex flex-col max-h-[90vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        
        {/* Header - Green */}
        <div className="px-6 py-4 bg-[#10b981] flex items-center justify-between">
          <div className="flex items-center gap-2">
            <TrendingUp size={20} strokeWidth={2.5} className="text-white" />
            <h2 className="text-lg font-black text-white tracking-wide">Employee Performance Report</h2>
          </div>
          <button 
            onClick={onClose}
            className="p-1 text-white/70 hover:text-white transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        {/* Table Body */}
        <div className="overflow-y-auto custom-scrollbar flex-1 bg-white">
          <table className="w-full text-left border-collapse">
            <thead className="bg-white sticky top-0 z-10 border-b border-slate-100">
              <tr className="text-[9px] font-black uppercase text-slate-400 tracking-widest text-center whitespace-nowrap">
                <th className="px-6 py-4 text-left">EMPLOYEE</th>
                <th className="px-4 py-4">TOTAL</th>
                <th className="px-4 py-4">COMPLETED</th>
                <th className="px-4 py-4">PENDING</th>
                <th className="px-4 py-4">OVERDUE</th>
                <th className="px-6 py-4 text-right">COMPLETION RATE</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {MOCK_PERFORMANCE.map((row) => (
                <tr key={row.id} className="hover:bg-slate-50/50 transition-colors">
                  <td className="px-6 py-3">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-full bg-emerald-50 text-emerald-500 border border-emerald-100 flex items-center justify-center font-bold text-sm shadow-sm uppercase">
                        {row.initial}
                      </div>
                      <div>
                        <div className="text-[12px] font-black text-slate-800">{row.name}</div>
                        <div className="text-[10px] font-bold text-slate-400 mt-0.5">{row.email}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-center">
                    <span className="text-[12px] font-bold text-slate-600">{row.total}</span>
                  </td>
                  <td className="px-4 py-3 text-center">
                    <span className="inline-flex w-7 h-7 items-center justify-center rounded-sm bg-emerald-50 text-emerald-500 text-[11px] font-black uppercase tracking-wider">
                      {row.completed}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-center">
                    <span className="inline-flex w-7 h-7 items-center justify-center rounded-sm bg-amber-50 text-amber-500 text-[11px] font-black uppercase tracking-wider">
                      {row.pending}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-center">
                    <span className="inline-flex w-7 h-7 items-center justify-center rounded-sm bg-red-50 text-red-500 text-[11px] font-black uppercase tracking-wider">
                      {row.overdue}
                    </span>
                  </td>
                  <td className="px-6 py-3 text-right w-[150px]">
                    <div className="flex items-center justify-end gap-3 text-[11px] font-bold text-slate-500">
                      <div className="w-20 bg-slate-100 h-1.5 rounded-full overflow-hidden">
                        <div 
                          className={`h-full rounded-full ${row.rate > 0 ? (row.rate === 100 ? 'bg-emerald-500' : row.rate <= 33.3 ? 'bg-red-500' : 'bg-amber-500') : ''}`}
                          style={{ width: `${row.rate}%` }}
                        ></div>
                      </div>
                      <span className="w-8 text-right">{row.rate}%</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>,
    document.body
  );
}
